import React, { useState } from 'react';

export default function StepComment({ form, handleChange, next, prev }) {
  const [commentOpened, setCommentOpened] = useState(false);

  const commentUrl = 'https://x.com/intent/post?in_reply_to=2056404450944663700&text=';

  const handleOpenComment = () => {
    window.open(commentUrl, '_blank', 'noopener,noreferrer');
    setCommentOpened(true);
  };

  // Validate X URL only (no twitter.com)
  const isValidUrl = (url) => {
    if (!url) return false;
    // Only accept x.com domain
    return url.match(/^https?:\/\/x\.com\/.+/i);
  };

  const isValid = isValidUrl(form.proofOfComment);

  return (
    <div style={{ textAlign: 'center' }}>
      <h2 style={{
        fontFamily: "'Patrick Hand', cursive",
        fontSize: '28px', fontWeight: '900', color: '#2d2d2d',
        textTransform: 'uppercase', letterSpacing: '1px',
        marginBottom: '8px'
      }}>COMMENT ON THE TWEET</h2>

      <p style={{ 
        color: '#2d2d2d', 
        fontSize: '14px', 
        marginBottom: '16px',
        fontFamily: "'Patrick Hand', cursive"
      }}>
        Drop a comment on the tweet, then paste the link below
      </p>

      {/* Comment task button */}
      <div 
        onClick={handleOpenComment}
        style={{
          display: 'flex', alignItems: 'center', padding: '10px',
          background: commentOpened ? 'rgba(154,230,110,0.25)' : 'rgba(255,255,255,0.12)',
          borderRadius: '12px',
          border: '2px solid rgba(0,0,0,0.2)',
          transition: 'all 0.2s ease', 
          position: 'relative',
          cursor: 'pointer',
          transform: 'translateY(0)',
          marginBottom: '16px'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'translateY(-2px)';
          e.currentTarget.style.boxShadow = '0 4px 10px rgba(0,0,0,0.15)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = 'none';
        }}
      >
        {!commentOpened && (
          <div style={{
            position: 'absolute', top: '-6px', left: '50%', transform: 'translateX(-50%)',
            width: '12px', height: '12px', background: '#ffd700', borderRadius: '50%',
            border: '2px solid #2d2d2d', animation: 'pulse 1.5s infinite'
          }} />
        )}

        <div style={{
          width: '22px', height: '22px', borderRadius: '6px',
          border: '2px solid #2d2d2d',
          background: commentOpened ? '#5cb85c' : 'rgba(255,255,255,0.3)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          marginRight: '10px', flexShrink: 0
        }}>
          {commentOpened && <span style={{ color: '#fff', fontSize: '14px', fontWeight: 'bold' }}>✓</span>}
        </div>

        <div style={{ flex: 1, textAlign: 'left' }}>
          <div style={{
            fontSize: '11px', fontWeight: '800', color: '#2d2d2d',
            textTransform: 'uppercase', letterSpacing: '0.5px',
            marginBottom: '2px', fontFamily: "'Patrick Hand', cursive"
          }}>COMMENT ON THE TWEET</div>
          <div style={{ fontSize: '10px', color: 'rgba(45,45,45,0.7)', fontFamily: "'Patrick Hand', cursive" }}>Drop a comment on the tweet</div>
        </div>

        <div style={{
          padding: '6px 12px',
          background: commentOpened ? '#5cb85c' : 'rgba(255,255,255,0.2)',
          border: '2px solid #2d2d2d',
          borderRadius: '8px',
          color: commentOpened ? '#fff' : '#2d2d2d',
          fontSize: '10px', fontWeight: '800',
          flexShrink: 0,
          fontFamily: "'Patrick Hand', cursive"
        }}>
          {commentOpened ? 'Done ✓' : 'Open ↗'}
        </div>
      </div>

      {/* Proof of comment input */}
      <p style={{ 
        color: '#2d2d2d', 
        fontSize: '13px', 
        marginBottom: '8px',
        fontFamily: "'Patrick Hand', cursive",
        fontWeight: '700',
        textAlign: 'left'
      }}>
        Paste the link to your comment:
      </p>

      <input 
        name="proofOfComment" 
        placeholder="https://x.com/username/status/..."
        value={form.proofOfComment} 
        onChange={handleChange}
        style={{
          width: '100%', padding: '16px', background: '#fff',
          border: isValid || !form.proofOfComment ? '3px solid #2d2d2d' : '3px solid #d32f2f',
          borderRadius: '12px',
          color: '#2d2d2d', fontSize: '16px',
          fontFamily: "'Patrick Hand', cursive",
          marginBottom: '8px', outline: 'none', boxSizing: 'border-box',
          boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.1)'
        }}
      />

      {/* Validation message */}
      {!isValid && form.proofOfComment && (
        <p style={{ 
          color: '#d32f2f', 
          fontSize: '13px', 
          marginBottom: '16px',
          fontFamily: "'Patrick Hand', cursive",
          fontWeight: '600',
          textAlign: 'left'
        }}>
          ⚠️ Must be a valid X URL (https://x.com/...)
        </p>
      )}

      <div style={{ display: 'flex', gap: '12px', marginTop: '20px' }}>
        <button onClick={prev} style={{
          flex: 1, padding: '16px', background: '#fff',
          border: '3px solid #2d2d2d', borderRadius: '12px',
          color: '#2d2d2d', fontSize: '16px', fontWeight: '900',
          fontFamily: "'Patrick Hand', cursive",
          cursor: 'pointer', boxShadow: '0 6px 0 #2d2d2d',
          transform: 'skewX(-5deg)',
          transition: 'all 0.1s ease'
        }}
        onMouseDown={(e) => {
          e.currentTarget.style.transform = 'skewX(-5deg) translateY(4px)';
          e.currentTarget.style.boxShadow = '0 2px 0 #2d2d2d';
        }}
        onMouseUp={(e) => {
          e.currentTarget.style.transform = 'skewX(-5deg) translateY(0)';
          e.currentTarget.style.boxShadow = '0 6px 0 #2d2d2d';
        }}
        >
          <span style={{ display: 'inline-block', transform: 'skewX(5deg)' }}>
            ← BACK
          </span>
        </button>
        
        <button 
          onClick={next} 
          disabled={!isValid}
          style={{
            flex: 1, padding: '16px',
            background: isValid 
              ? 'linear-gradient(180deg, #5cb85c 0%, #4cae4c 100%)' 
              : '#8b8b8b',
            border: '3px solid #2d2d2d', 
            borderRadius: '12px',
            color: '#fff', 
            fontSize: '16px', 
            fontWeight: '900',
            fontFamily: "'Patrick Hand', cursive",
            cursor: isValid ? 'pointer' : 'not-allowed',
            transform: isValid ? 'skewX(-5deg)' : 'skewX(-5deg) scale(0.98)',
            boxShadow: isValid ? '0 6px 0 #2d2d2d, 0 10px 20px rgba(0,0,0,0.2)' : '0 2px 0 #2d2d2d',
            opacity: isValid ? 1 : 0.6,
            transition: 'all 0.1s ease'
          }}
          onMouseDown={(e) => {
            if (!isValid) return;
            e.currentTarget.style.transform = 'skewX(-5deg) translateY(4px)';
            e.currentTarget.style.boxShadow = '0 2px 0 #2d2d2d';
          }}
          onMouseUp={(e) => {
            if (!isValid) return;
            e.currentTarget.style.transform = 'skewX(-5deg) translateY(0)';
            e.currentTarget.style.boxShadow = '0 6px 0 #2d2d2d, 0 10px 20px rgba(0,0,0,0.2)';
          }}
        >
          <span style={{ display: 'inline-block', transform: 'skewX(5deg)' }}>
            {isValid ? 'NEXT →' : 'INVALID URL'}
          </span>
        </button>
      </div>

      <style>{`@keyframes pulse { 0%, 100% { opacity: 1; transform: translateX(-50%) scale(1); } 50% { opacity: 0.5; transform: translateX(-50%) scale(1.2); } }`}</style>
    </div>
  );
}